import ImageWithLoadSpinner from './ImageWithLoadSpinner';

export default ImageWithLoadSpinner;
